import { useState, useEffect } from "react";
import {
  getPaidTesterByRef,
  getPaidTesterByEmail,
  getPaidTesterByLastFour,
} from "../graphql/queries";
import { API } from "aws-amplify";
import {
  Box,
  Text,
  Button,
  Form,
  FormField,
  TextInput,
  Heading,
} from "grommet";
import PodPaymentCard from "./PodPaymentCard";

function PodPaymentValidation({
  referenceId,
  email,
  lastFour,
  user,
  setPaymentValidation,
}) {
  const [possibleMatches, setPossibleMatches] = useState([]);
  const [searchForm, setSearchForm] = useState({
    searchTerm: "",
  });

  useEffect(() => {
    let temp = [];
    // get values from refId, email, and lastFour, combine into one array
    async function checkByReferenceId(referenceId) {
      const cleanedReferenceId = referenceId.replace(/#/g, "");
      const response = await API.graphql({
        query: getPaidTesterByRef,
        variables: {
          referenceId: cleanedReferenceId.toLowerCase(),
        },
      });
      console.log("referenceId response", response);
      if (response.data.testerByReferenceId.items.length > 0) {
        temp.push(...response.data.testerByReferenceId.items);
      }
    }
    async function checkByEmail(email) {
      const response = await API.graphql({
        query: getPaidTesterByEmail,
        variables: {
          cust_email: email,
        },
      });
      console.log("email response", response);
      if (response.data.testerByEmail.items.length > 0) {
        temp.push(...response.data.testerByEmail.items);
      }
    }
    async function checkByLastFour(lastFour) {
      const response = await API.graphql({
        query: getPaidTesterByLastFour,
        variables: {
          lastFour: lastFour,
        },
      });
      console.log("lastFour response", response);
      if (response.data.testerByLastFour.items.length > 0) {
        temp.push(...response.data.testerByLastFour.items);
      }
    }

    async function fetchAllData() {
      const promises = [];

      if (referenceId !== "") {
        promises.push(checkByReferenceId(referenceId));
        promises.push(checkByLastFour(referenceId));
      }
      if (email !== "") {
        promises.push(checkByEmail(email));
      }
      if (lastFour !== "") {
        promises.push(checkByLastFour(lastFour));
      }

      // Wait for all API calls to complete
      await Promise.all(promises);

      // Filter out duplicates based on paymentId
      const uniqueMatches = temp.filter(
        (match, index, self) =>
          index === self.findIndex((m) => m.paymentId === match.paymentId)
      );

      // Sort by createdAt from newest to oldest
      const sortedMatches = uniqueMatches.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      console.log("temp", temp);
      console.log("uniqueMatches", uniqueMatches);
      console.log("sortedMatches", sortedMatches);
      setPossibleMatches(sortedMatches);
    }

    fetchAllData();
  }, [referenceId, email, lastFour]);

  const handleManualSearch = async () => {
    let temp = [];
    const searchTerm = searchForm.searchTerm.trim();

    if (searchTerm === "") {
      setPossibleMatches([]);
      return;
    }

    async function checkByReferenceId(referenceId) {
      const cleanedReferenceId = referenceId.replace(/#/g, "");
      const response = await API.graphql({
        query: getPaidTesterByRef,
        variables: {
          referenceId: cleanedReferenceId.toLowerCase(),
        },
      });
      console.log("referenceId response", response);
      if (response.data.testerByReferenceId.items.length > 0) {
        temp.push(...response.data.testerByReferenceId.items);
      }
    }
    async function checkByEmail(email) {
      const response = await API.graphql({
        query: getPaidTesterByEmail,
        variables: {
          cust_email: email,
        },
      });
      console.log("email response", response);
      if (response.data.testerByEmail.items.length > 0) {
        temp.push(...response.data.testerByEmail.items);
      }
    }
    async function checkByLastFour(lastFour) {
      const response = await API.graphql({
        query: getPaidTesterByLastFour,
        variables: {
          lastFour: lastFour,
        },
      });
      console.log("lastFour response", response);
      if (response.data.testerByLastFour.items.length > 0) {
        temp.push(...response.data.testerByLastFour.items);
      }
    }

    const promises = [];

    // Search with the same term across all three criteria
    promises.push(checkByReferenceId(searchTerm));
    promises.push(checkByEmail(searchTerm));
    promises.push(checkByLastFour(searchTerm));

    // Wait for all API calls to complete
    await Promise.all(promises);

    // Filter out duplicates based on paymentId
    const uniqueMatches = temp.filter(
      (match, index, self) =>
        index === self.findIndex((m) => m.paymentId === match.paymentId)
    );

    // Sort by createdAt from newest to oldest
    const sortedMatches = uniqueMatches.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    console.log("manual search temp", temp);
    console.log("manual search uniqueMatches", uniqueMatches);
    console.log("manual search sortedMatches", sortedMatches);
    setPossibleMatches(sortedMatches);
  };
  return (
    <>
      {/* Dark overlay for background */}
      <Box
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 9998,
          pointerEvents: "auto",
        }}
        onClick={() => {
          setPossibleMatches([]);
          setPaymentValidation(false);
        }}
      />

      {/* Side panel */}
      <Box
        background="light-2"
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          width: "60%",
          minWidth: "500px",
          zIndex: 9999,
          pointerEvents: "auto",
          boxShadow: "-4px 0 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box fill>
          {/* Close button at top left */}
          <Box
            align="start"
            justify="start"
            pad="small"
            style={{ position: "absolute", top: 0, left: 0, zIndex: 10000 }}
          >
            <Button
              label="✕"
              onClick={() => {
                setPossibleMatches([]);
                setPaymentValidation(false);
              }}
              primary
            />
          </Box>

          <Box
            align="center"
            justify="start"
            pad="small"
            fill
            gap="small"
            style={{ overflowY: "auto" }}
          >
            {/* Search Form */}
            <Box
              margin={{ bottom: "medium" }}
              align="center"
              round="small"
              width="large"
              overflow="grow"
            >
              <Form
                value={searchForm}
                onChange={setSearchForm}
                onSubmit={({ value }) => handleManualSearch()}
              >
                <Box gap="xsmall" pad="xsmall">
                  <FormField
                    label="Search by Order, Email, Last 4 Digits, or prepaid code"
                    name="searchTerm"
                    margin="none"
                    background="white"
                    round="small"
                  >
                    <TextInput
                      name="searchTerm"
                      placeholder="Enter order number, email, last 4 digits, or prepaid code"
                      background="white"
                    />
                  </FormField>
                </Box>
                <Box align="center">
                  <Button type="submit" label="Search" primary size="small" />
                </Box>
              </Form>
            </Box>
            {possibleMatches.length === 0 ? (
              <Text>No matches found</Text>
            ) : (
              <Text margin={{ bottom: "medium" }}>
                Found {possibleMatches.length} match
                {possibleMatches.length !== 1 ? "es" : ""} ordered newest to
                oldest, scroll to see more
              </Text>
            )}
            {possibleMatches.length > 0 && (
              <Box
                direction="column"
                gap="small"
                fill="horizontal"
                style={{
                  maxHeight: "60vh",
                  overflowY: "auto",
                  padding: "0 10px",
                }}
                align="center"
              >
                {possibleMatches.map((match) => (
                  <Box
                    key={match.paymentId}
                    style={{ minHeight: "auto", height: "auto" }}
                  >
                    <PodPaymentCard test={match} user={user} />
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default PodPaymentValidation;
